<!-- HERO -->
<header class="masthead">
  <div class="container h-100">
    <div class="row h-100 align-items-center">
      <div class="col-12 text-center">
        <h1 class="outline-title">Publicidad Digital</h1>
      </div>
    </div>
  </div>
</header>
<section class="modern-service-hero-section py-5">
  <div class="container px-5 my-5">
    <div class="row align-items-center">
      <div class="col-lg-7">
        <a class="service-detail-back" routerLink="/servicios">
          <i class="bi bi-arrow-left"></i>
          Servicios
        </a>
        <h1 class="modern-section-title mb-3">
          Publicidad digital diseñada para <span class="highlight-green">generar resultados</span>
        </h1>
        <div class="section-underline"></div>
        <p class="lead text-light mb-4">
          Campañas estratégicas, creativas y medibles para conectar con audiencias reales y acelerar crecimiento.
        </p>
        <ul class="modern-checklist">
          <li><i class="bi bi-check-circle-fill"></i> Evaluación y optimización en tiempo real</li>
          <li><i class="bi bi-check-circle-fill"></i> Diseño personalizado con enfoque comercial</li>
          <li><i class="bi bi-check-circle-fill"></i> Informes claros y accionables</li>
        </ul>
      </div>
      <div class="col-lg-5 text-center">
        <app-service-orbit-visual iconClass="bi bi-megaphone"></app-service-orbit-visual>
      </div>
    </div>
  </div>
</section>

<!-- CARDS DE SERVICIOS -->
<section class="modern-service-cards-section py-5">
  <div class="container">
    <div class="row g-4">
      <div class="col-md-4 d-flex">
        <div class="modern-service-card glass-card w-100 text-center">
          <div class="icon-box mx-auto mb-3">
            <i class="bi bi-badge-ad"></i>
          </div>
          <h4 class="modern-service-card-title">Publicidad Nativa</h4>
          <p>Integramos anuncios de forma natural en el contenido para generar interacción genuina y mayor
            engagement.</p>
        </div>
      </div>
      <div class="col-md-4 d-flex">
        <div class="modern-service-card glass-card w-100 text-center">
          <div class="icon-box mx-auto mb-3">
            <i class="bi bi-link-45deg"></i>
          </div>
          <h4 class="modern-service-card-title">Estrategias de Afiliados</h4>
          <p>Conectamos tu marca con audiencias específicas para generar acciones medibles y oportunidades comerciales.</p>
        </div>
      </div>
      <div class="col-md-4 d-flex">
        <div class="modern-service-card glass-card w-100 text-center">
          <div class="icon-box mx-auto mb-3">
            <i class="bi bi-bar-chart-line"></i>
          </div>
          <h4 class="modern-service-card-title">Analítica y Optimización</h4>
          <p>Monitoreamos y ajustamos campañas para maximizar rendimiento, retorno e impacto.</p>
        </div>
      </div>
    </div>
  </div>
</section>

<!-- SECCIÓN POR QUÉ ELEGIRNOS -->
<section class="modern-service-why-section py-5">
  <div class="container px-5 my-5">
    <div class="row align-items-center">
      <div class="col-md-6">
        <h2 class="modern-section-title mb-3">
          ¿Por qué <span class="highlight-green">elegirnos?</span>
        </h2>
        <div class="section-underline"></div>
        <ul class="modern-checklist">
          <li><i class="bi bi-check-circle-fill"></i> Experiencia en campañas orientadas a resultados</li>
          <li><i class="bi bi-check-circle-fill"></i> Estrategias personalizadas según objetivo</li>
          <li><i class="bi bi-check-circle-fill"></i> Transparencia y comunicación constante</li>
        </ul>
      </div>
      <div class="col-md-6">
        <div class="glass-card p-4">
          <p class="mb-0 text-light">
            Lleva tu marca al siguiente nivel con campañas publicitarias que realmente generan resultados.
          </p>
        </div>
      </div>
    </div>
  </div>
</section>
